<section class="section-title">

  <h1 i18n="@@privacy_terms_title">Informativa d'uso e Condizioni del servizio</h1>

</section>

<section>

  <div class="control-card-white no-border" id="register-card">

    <div class="control-card-content">

      <div id="privacy" style="overflow-y:scroll; overflow-x:hidden; width:100%; height:280px;">
        <app-privacy></app-privacy>
      </div>

      <!-- LOREM IPSUM, nascosto -->
      <!-- <div id="terms" class="margin-top-30" style="overflow-y:scroll; overflow-x:hidden; width:100%; height:280px;">
        <app-terms></app-terms>
      </div> -->

    </div>

  </div>

</section>
